import _ from 'lodash';
import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Search from "@material-ui/icons/Search";
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import _404PageStyle from 'assets/jss/material-kit-react/views/404Page.jsx';
import nebula from "assets/img/background/imax_nebula1920.jpg";
// TODO validation doesnt actually do anything? firebase checks email already used also...
// import asyncValidate from './asyncValidate';
import {getRandPoll} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';
import SearchGrid from 'components/SearchGrid/SearchGrid.jsx';

class PageNotFound extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      query: '',
    };
  }

  componentDidMount() {
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      500
    );
  }

  clickSearchBtn() {
    const {query} = this.state;
    if (query.length < 3) {
      alert('You must search for something at least 3 characters long!')
    } else {
      this.props.searchPolls(query);
    }
  }

  updateSearchField = event => {
    this.setState({ query: event.target.value });
  };

  renderInvalidUrl() {
    const invalid_url = this.props.location.state.from ? this.props.location.state.from : '';
    if (invalid_url && this.props.isRedirect){
      return <p style={{fontSize: 16, fontStyle: "italic"}}>{`https://www.pollpals.com${invalid_url}`}</p>;
    }
  }

  renderNotFoundSketch() {
    const {classes} = this.props;
    return (
      <CardBody>
        <div className={classes.site}>
        	<div className={classes.sketch}>
        		<div className="bee-sketch red"></div>
        		<div className="bee-sketch blue"></div>
        	</div>
          <h2>404: Invalid url</h2>
          {this.renderInvalidUrl()}
          <h4>Typo? Or the page you're looking for does not exist... </h4>
        </div>
      </CardBody>
    );
  }

  render404Btns() {
    const {classes} = this.props;
    return (
      <CardFooter className={classes.cardFooter}>
        <Button style={{marginRight: 10}} color="primary" size="lg">
          <Link style={{color: 'inherit'}} to='/poll/search'>
            Search Existing Polls
          </Link>
        </Button>
        <p>{"\n"}</p>
        <Button color="primary" size="lg">
          <Link style={{color: 'inherit'}} to='/poll/create'>
            Create Poll
          </Link>
        </Button>
      </CardFooter>
    );
  }

  render() {
    const {classes, ...rest} = this.props;

    return (
      <div>
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + nebula + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem md={12} md={10} >
                <Card className={classes[this.state.cardAnimaton]}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Page Not Found.</h3>
                  </CardHeader>
                  {this.renderNotFoundSketch()}
                  {this.render404Btns()}
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Footer whiteFont />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    poll: state.poll,
  };
}

const pageWithStylesAndFirebase = withStyles(_404PageStyle)(withFirebase(PageNotFound));

export default withRouter(connect(mapStateToProps, {getRandPoll})(pageWithStylesAndFirebase));



// WEBPACK FOOTER //
// ./src/views/PageNotFound.js